module.exports = __webpack_public_path__ + "img/tpc-9.ee0164fb.webp";